import {
  LOAD_SUCCESS_AGENTS,
  LOAD_FAIL_AGENTS,
  SAVE_SUCCESS_AGENTS,
  SAVE_FAIL_AGENTS,
  UPDATE_SUCCESS_AGENTS,
  UPDATE_FAIL_AGENTS,
  DELETE_SUCCESS_AGENTS,
  DELETE_FAIL_AGENTS,
} from "../actions/agentAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_AGENTS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_AGENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_AGENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_AGENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_AGENTS:
      const updatedListe = [];
      state.data.forEach((item) => {
        if (item.agent_id === action.payload.agent_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_AGENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_AGENTS:
      const filtered = state.data.filter((item) => {
        return item.groupe_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_AGENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
